import {
  useModalCompleteProfileStore,
  useModalPlansStore,
  useModalTermsConditionsStore
} from '../../store'
import { useModalBrokerInvitationStore } from '../../store/modals-services/modal-broker-invitation'
import { useModalWelcomeWiggotStore } from '../../store/modals-services/modal-welcome-wiggot'
import {
  ModalCompleteProfile,
  ModalPlans,
  ModalTermsAndConditions
} from './modals'
import { ModalBrokerInvitation } from './modals/modal-broker-invitation/ModalBrokerInvitation'
import { ModalWelcomeWiggot } from './modals/modal-welcome-wiggot/ModalWelcomeWiggot'

export const ModalsServices = () => {
  const isOpenModalPlans = useModalPlansStore((state) => state.isOpen)

  const isOpenModalTermsConditions = useModalTermsConditionsStore(
    (state) => state.isOpen
  )

  const isOpenModalCompleteProfile = useModalCompleteProfileStore(
    (state) => state.isOpen
  )

  const isOpenModalBrokerInvitation = useModalBrokerInvitationStore(
    (state) => state.isOpen
  )

  const isOpenModalWelcomeWiggot = useModalWelcomeWiggotStore(
    (state) => state.isOpen
  )

  return (
    <>
      {isOpenModalPlans && <ModalPlans />}
      {isOpenModalTermsConditions && <ModalTermsAndConditions />}
      {isOpenModalCompleteProfile && <ModalCompleteProfile />}
      {isOpenModalBrokerInvitation && <ModalBrokerInvitation />}
      {isOpenModalWelcomeWiggot && <ModalWelcomeWiggot />}
    </>
  )
}
